"use client"

import { useRouter, useSearchParams } from "next/navigation"
import { useLocale, useTranslations } from "next-intl"
import { TextButton } from "@/shared/ui/atoms"
import { withSafeRedirectParam } from "@/shared/lib/safe-redirect"

const EmailSignInButtons = () => {
  const t = useTranslations()
  const router = useRouter()
  const locale = useLocale()
  const redirectUrl = useSearchParams()?.get("redirect")
  
  return (
    <div className="mt-5 flex items-center justify-center gap-3">
      <TextButton size={14} className="text-[#70737C] leading-[20px]" text={t("emailSignIn")} onClick={() => router.push(withSafeRedirectParam(`/${locale}/sign-in/email`, redirectUrl))} />
      <span className="bg-[#E5E7EB] w-[1px] h-[12px]" />
      <TextButton size={14} className="text-[#70737C] leading-[20px]" text={t("emailSignup")} onClick={() => router.push(withSafeRedirectParam(`/${locale}/sign-up`, redirectUrl))} />
    </div>
  )
}

export default EmailSignInButtons
